import styled from '@emotion/styled';
import { Box, Grid, Typography } from '@mui/material';
import { colors } from 'theme/colors';
import { Chips } from 'components/atoms/Chips';

const StyledCard = styled(Box)`
  padding: 20px;
  background: #ffffff;
  border: 1px solid ${colors.blue100};
  box-shadow: 0 2px 4px rgba(194, 204, 243, 0.35), 0 2px 6px rgba(194, 204, 243, 0.3),
    0 4px 8px rgba(194, 204, 243, 0.2), 0 6px 10px rgba(194, 204, 243, 0.2);
  border-radius: 4px;
`;

const StyledChips = styled(Chips)`
  width: 100%;

  & span {
    justify-content: center;
  }
`;

const StyledDashboardChips = styled(Chips)`
  & span {
    padding: 13px !important;
    justify-content: center;
  }
`;

const StyledApplicationTitle = styled(Grid)`
  height: 108px;

  & h5 {
    font-weight: 700;
    font-size: 20px;
    line-height: 28px;
    text-align: center;
    padding: 30px 0;
  }
`;

const StyledTitle = styled(Typography)`
  font-weight: 700;
  padding-bottom: 20px;
  padding-top: 24px;
  border-bottom: 1px solid ${colors.black};
  font-style: bold;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: 0%;
`;

const StyledTableBox = styled(Grid)`
  background: ${colors.white};
  border: 1px solid ${colors.blue100};
  box-shadow: 0px 6px 10px 0px #c2ccf333, 0px 4px 8px 0px #c2ccf333, 0px 2px 6px 0px #c2ccf34d,
    0px 2px 4px 0px #c2ccf359;
  margin-bottom: 24px;
`;
const StyledTableBoxItem = styled(Grid)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0 20px 0;
  &:not(:last-child) {
    border-bottom: 1px solid ${colors.blue100};
  }
`;

export {
  StyledCard,
  StyledChips,
  StyledApplicationTitle,
  StyledTitle,
  StyledTableBox,
  StyledTableBoxItem,
  StyledDashboardChips,
};
